import React from "react";
import "./Main.css";
function Main() {
  return (
    <main className="main" id="inicio">
      {/* Conteúdo */}
      <div className="main-content">
        <h1>
          LORETECH.LS
          <br />
          <span>Transformando seu sonho através de um click!</span>
        </h1>

        <p>
          Mais do que software, entregamos inteligência de execução combinando
          especialistas de alto nível para transformar seus projetos em
          resultados reais, com precisão e controle.
        </p>

        <a
          href="https://wa.me/5511988833017"
          target="_blank"
          rel="noopener noreferrer"
          className="main-btn"
        >
          Fale com um especialista →
        </a>
      </div>

      {/* WhatsApp flutuante */}
      <a
        href="https://wa.me/5511988833017"
        className="whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </main>
  );
}

export default Main;
